export default "__VITE_ASSET__92f21957__"